import eventMixin from '../lib/mixins/event';
import Logger from '../lib/logger';
import KeenSlider from 'keen-slider';

export default class SectionTestimonialBetterdays {

	constructor(dom) {

		// Vars
		// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
		this.NAME = `SectionTestimonialBetterdays`;

		this.dom = dom;
		this.slidesDom = this.dom.querySelector(`[data-section-testimonial-betterdays-slides]`);

		this.nextButton = this.dom.querySelector(`[data-section-testimonial-betterdays-next-button]`);
		this.prevButton = this.dom.querySelector(`[data-section-testimonial-betterdays-prev-button]`);

	}

	// Logic
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
	init() {
		Logger.info(`${this.NAME} > init`);

		const self = this;

		/**
		* Initialize the marquee when visible
		*/
		const observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				const intersecting = entry.isIntersecting;

				if (intersecting && !this.isScrolling) {
					setTimeout(() => {
						self.initCarousel();
					}, 1000);
				}
			})
		})

		observer.observe(this.dom);
	}

	initCarousel() {
		Logger.info(`${this.NAME} > initCarousel`);

		const slider = new KeenSlider(
			this.slidesDom,
			{
				selector: `[data-section-testimonial-betterdays-slide]`,
				loop: true,
				slides: {
					perView: 2,
					spacing: 64
				},
				breakpoints: {
					'(max-width: 768px)': {
						loop: true,
						slides: {
							perView: 1,
							spacing: 32
						},
					},
				},
				created: () => {
					this.slidesDom.classList.add(`testimonials-betterdays__slides--active`);
				},
			},
			[
				// add plugins here
			]
		);

		this.prevButton.addEventListener('click', (e) => {
			e.preventDefault();
			slider.prev();
		});
		this.nextButton.addEventListener('click', (e) => {
			e.preventDefault();
			slider.next();
		});
	}

}

// Mixins
Object.assign(SectionTestimonialBetterdays.prototype, eventMixin);
